import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = ({ t }) => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="mb-12">
          <div className="bg-slate-800 rounded-lg p-6 mb-8">
            <h3 className="text-xl font-semibold text-teal-400 mb-4">{t.company}</h3>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">{t.serviceDescription}</p>

            <div className="space-y-4">
              <h4 className="text-lg font-medium text-teal-400">{t.howItWorks}</h4>
              <p className="text-slate-300 text-sm leading-relaxed">{t.howItWorksText}</p>
              <p className="text-slate-300 text-sm leading-relaxed">{t.subscription}</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-teal-400">{t.company}</h3>
            <p className="text-slate-300">{t.tagline}</p>
            <div className="flex space-x-4">
              <a href="#section-1" className="text-slate-400 hover:text-teal-400 transition-colors duration-200" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#section-1" className="text-slate-400 hover:text-teal-400 transition-colors duration-200" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#section-1" className="text-slate-400 hover:text-teal-400 transition-colors duration-200" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#section-1" className="text-slate-300 hover:text-teal-400 transition-colors duration-200">
                  {t.navHome}
                </a>
              </li>
              <li>
                <a href="#section-2" className="text-slate-300 hover:text-teal-400 transition-colors duration-200">
                  {t.navFeatures}
                </a>
              </li>
              <li>
                <a href="#section-3" className="text-slate-300 hover:text-teal-400 transition-colors duration-200">
                  {t.navHow}
                </a>
              </li>
              <li>
                <a href="#section-4" className="text-slate-300 hover:text-teal-400 transition-colors duration-200">
                  {t.navBenefits}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-teal-400" />
                <span className="text-slate-300">{t.address}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-teal-400" />
                <a href={`mailto:${t.email}`} className="text-slate-300 hover:text-teal-400">
                  {t.email}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-teal-400" />
                <a href={`tel:${t.phone.replace(/\s/g, '')}`} className="text-slate-300 hover:text-teal-400">
                  {t.phone}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-slate-400 text-sm">
              <p>
                © 2026 {t.company}. {t.rights}
              </p>
              <p className="mt-1">{t.clickzillas}</p>
            </div>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              <a href="/contact/" className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm">
                {t.contactLink}
              </a>
              <a href="/tc/" className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm">
                {t.terms}
              </a>
              <a href="/help/" className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm">
                {t.privacy}
              </a>
              <a href="/withdrawal/" className="text-slate-400 hover:text-teal-400 transition-colors duration-200 text-sm">
                {t.cookies}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
